import NotAssignedTable from './components/notAssignedTable';
import AssignedTable from './components/assignedTable';
import {
  useChangeModeMutation,
  useLazyGetAssignmentQuery
} from '../../../../../../../../features/authentication/assignmentApislice';
import {
  useAssignStudentsMutation
} from '../../../../../../../../features/authentication/assignApiSlice';
import { useState, useEffect } from 'react';
import { useAssignmentContext } from '../../../../../../context';
import { Form, Button } from 'react-bootstrap';
import { faXmark } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomToast from '../../../../../../../../components/Toast';
import AssignmentSettings from '../../../../../../../../components/AssignmentSettings/index';
import ConfirmationModal from '../../../../../../../../components/ConfirmationPopUp';
import DropDownSearch from '../../../../../../../../components/DropDownSearch';
import moment from 'moment';
import { useGetClassFilterMutation, useUpdateClassFilterMutation } from '../../../../../../../../features/authentication/persistApiSlice';
import { useGetClassesMutation } from '../../../../../../../../features/authentication/authApiSlice';
import { useCheckIsStudentPdfExistMutation } from '../../../../../../../../features/authentication/pdfGeneratorApiSlice';
import { useParams } from 'react-router';
import ActivitySettings from '../../../../../../../activities/components/ActivitySettings';
import ActivityTypes from '../../../../../../../../enums/activityTypes';
import { useActivityContext } from '../../../../../../../activities/context';
import { useAssignStudentsInFlashcardMutation } from '../../../../../../../../features/authentication/activityApiSlice';

function AssignCastle() {
  const [activeTab, setActiveTab] = useState(0);
  const [trigger, result] = useLazyGetAssignmentQuery();
  const { assignmentId } = useAssignmentContext();
  const [selectedClassFilterIds, setSelectedClassFilterIds] = useState([]);
  const [filterClassList, setFilterClassList] = useState([]);
  const [notAssignedStudents, setNotAssignedStudents] = useState([]);
  const [assignedStudents, setAssignedStudents] = useState([]);
  const [assignStudentsInAssignment] = useAssignStudentsMutation();
  const [assignStudentsInFlashcard] = useAssignStudentsInFlashcardMutation();
  const [isAssigningStudents, setIsAssigningStudents] = useState(false);
  const [setclassFilter] = useUpdateClassFilterMutation();
  const [isLoading, setIsLoading] = useState(false);
  const [confirmModel, setConfirmModel] = useState(false);
  const [allClassList, setAllClassList] = useState([]);
  const [isIncludeCR, setIsIncludeCR] = useState(false);
  const [cRQuestionExists, setCRQuestionExists] = useState(false);
  const [getClassFilter] = useGetClassFilterMutation();
  const [getAllClasses] = useGetClassesMutation();
  const [checkIsStudentPdfExist] = useCheckIsStudentPdfExistMutation();
  const [showStudentPrinting, setShowStudentPrinting] = useState(false);
  const [assignmentIsRetakeEnabled, setAssignmentIsRetakeEnabled] = useState(false);

  const [showAssignmentSettings, setShowAssignmentSettings] = useState(true);
  const [changeMode] = useChangeModeMutation();
  const {activityType = ActivityTypes.Assignment } = useParams();
  const assignmentContext = useAssignmentContext();
  const activityContext = useActivityContext();
  const context = activityType == ActivityTypes.FlashCard ? activityContext : assignmentContext;

  let tabs = [
    <NotAssignedTable
      key="notAssignedTable"
      notAssignedStudents={notAssignedStudents}
      setNotAssignedStudents={setNotAssignedStudents}
      selectedClassFilterIds={selectedClassFilterIds}
      refetchCallback={() => refetch()}
      dataStatus={result}
      showAssignmentSettings={showAssignmentSettings}
      setShowAssignmentSettings={setShowAssignmentSettings}
      isLoading = {isLoading}
    />,
    <AssignedTable
      key="assignedTable"
      assignedStudents={assignedStudents}
      setAssignedStudents={setAssignedStudents}
      selectedClassFilterIds={selectedClassFilterIds}
      refetchCallback={() => refetch()}
      dataStatus={result}
      assignmentHasCRQuestions={result}
      isIncludeCRQuestion={isIncludeCR}
      showAssignmentSettings={showAssignmentSettings}
      setShowAssignmentSettings={setShowAssignmentSettings}
      assignmentRetakeEnabled={assignmentIsRetakeEnabled}
      isLoading = {isLoading}
    />
  ];

  useEffect(() => {
    loadInitialData();
    checkIsStudentPdfExistAsync();
  }, []);

  const checkIsStudentPdfExistAsync = async ()=>{
    const response = await checkIsStudentPdfExist([assignmentId]).unwrap();
    setShowStudentPrinting(response.isStudentPdfExist);
  };

  useEffect(() => {
    if (selectedClassFilterIds.length > 0) 
      refetch();
  }, [selectedClassFilterIds]);

  async function loadInitialData()
  {
    var persistIds = await getClassFilter().unwrap();
    let classes = localStorage.getItem('classes');
    if (classes) {
      classes = JSON.parse(classes);
    }else
    {
      classes = await getAllClasses().unwrap();
      localStorage.setItem('classes', JSON.stringify(classes));
    }

    const formattedClasses = classes.map((item) => ({
      name: item.className,
      id: item.classID,
      description: item.coTeacherClass ? item.teacherName : '',
      isChecked: persistIds?.includes(item.classID),
    }));
    setAllClassList(formattedClasses);
    setFilterClassList(formattedClasses);
    setSelectedClassFilterIds(persistIds);
  }

  function refetch() {
    setIsLoading(true);
    const option = {
      assignmentId: assignmentId,
      classIds: selectedClassFilterIds
    };
    trigger(option).then((response) => {
      if (response.isSuccess) {
        setIsIncludeCR(response.data.crGradingAvailable);
        setCRQuestionExists(response.data.includesCRQuestions);
        setNotAssignedStudents(response.data.unassignedStudents.filter(x=>!x.isRemoved) );
        setAssignedStudents(response.data.assignmentResults);
        setAssignmentIsRetakeEnabled(response.data.retakeEnabled ?? false);
        context.setRetakesEnabled(false);
      } else {
        console.log(response.error);
        setNotAssignedStudents([]);
        setAssignedStudents([]);
      }
    }).finally(()=>{
      setIsLoading(false);
    });
  }

  const handleClassSelectionChange = (e) => {
    const { key } = e;
    const selected = key !== '000' ? filterClassList.find((v) => v.id == key) : filterClassList;
    let tempValue = [];

    if (key === '000') {
      tempValue = filterClassList.map((item) => ({
        ...item,
        isChecked: !filterClassList.filter((item) => item?.isChecked !== true).length < 1
      }));
    } else {
      tempValue = filterClassList.map((item) =>
        item.id == key ? { ...item, isChecked: !selected.isChecked } : item
      );
    }
    setFilterClassList(tempValue);
    const ids = tempValue.filter((item) => item?.isChecked === true).map((itemId) => itemId.id);
    setSelectedClassFilterIds(ids);
    setClassIdsFilter(ids);
    setAssignedStudents([]);
    setNotAssignedStudents([]);
  };

  async function handleAssignStudents() {
    var selectedStudents = [];

    if (activeTab === 0) {
      selectedStudents = notAssignedStudents
        .filter((s) => s.isChecked)
        .map((student) => ({ studentId: student.studentId, classId: student.classId }));
    } else {
      selectedStudents = assignedStudents
        .filter((s) => s.isChecked)
        .map((student) => ({ studentId: student.studentId, classId: student.classId }));
    }

    const timedTimeSpan =
      parseInt(context.timedHour) * 60 + parseInt(context.timedMinute);

    if (selectedStudents.length <= 0) {
      CustomToast('Please check at least one student in the list', 'info');
      return;
    }
    if(activityType == ActivityTypes.Assignment){
      if (context.availabilityOption !== 'offline') {
        if (!context.assignmentMode) {
          CustomToast('Please select the assignment mode', 'info');
          return;
        }
      }
    }
    if (context.isTimed && timedTimeSpan <= 0) {
      CustomToast('The time length must be greater than 0 minutes.', 'info');
      return;
    }
    if (context.availabilityOption == 'FromTo') {
      const currentDate = moment().format('YYYY/MM/DD h:mm A'); // Get the current date/time
      if(moment(context.startDate).isBefore(currentDate, 'day')){
        CustomToast('From Date must not be before the current day', 'error');
        return;
      }
      if(moment(context.endDate).isBefore(currentDate)){
        CustomToast('To Date must not be before the current date/time', 'error');
        return;
      }
      if(moment(context.endDate).isBefore(moment(context.startDate)) || moment(context.endDate).isSame(moment(context.startDate))){
        CustomToast('To Date must be after the From Date', 'error');
        return;
      }
    }

    if (context.retakesEnabled) {
      const retakeTimeSpan = parseInt(context.retakeTimedHour * 60) + parseInt(context.retakeTimedMinute);
      if (context.retakeLimitValue <= 0) {
        CustomToast('You must select a retake limit', 'info');
        return;
      }
      if (context.retakeAvailabilty == 'fromto') {
        const currentDate = moment().format('YYYY/MM/DD h:mm A'); // Get the current date/time
        if(moment(context.retakeStartDate).isBefore(currentDate, 'day')){
          CustomToast('Retake From Date must not be before the current day', 'error');
          return;
        }
        if(moment(context.retakeEndDate).isBefore(currentDate)){
          CustomToast('Retake To Date must not be before the current date/time', 'error');
          return;
        }
        if(moment(context.retakeEndDate).isBefore(moment(context.retakeStartDate)) || moment(context.retakeEndDate).isSame(moment(context.retakeStartDate))){
          CustomToast('Retake To Date must be after the Retake From Date', 'error');
          return;
        }
      }
      if (context.isRetakeTimed && retakeTimeSpan <= 0) {
        CustomToast('The retake time length must be greater than 0 minutes.', 'info');
        return;
      }
      if (context.retakeQuestion === null || context.retakeQuestion == -1) {
        CustomToast(
          'You must select an option for Auto Graded Questions to include on Retakes',
          'info'
        );
        return;
      }
      if (context.includeCR === null || context.includeCR == -1) {
        CustomToast('You must select an option for CR Questions to include on Retakes', 'info');
        return;
      }
    }
    if (activeTab === 0) {
      if (cRQuestionExists && context.retakesEnabled)
        setConfirmModel(true);
      else assignStudentsApiCall();
    } else {
      assignStudentsApiCall();
    }
  }

  const assignStudentsApiCall = async () => {
    var selectedStudents = [];
    if (activeTab === 0) {
      selectedStudents = notAssignedStudents
        .filter((s) => s.isChecked)
        .map((student) => ({ studentId: student.studentId, classId: student.classId }));
    } else {
      selectedStudents = assignedStudents
        .filter((s) => s.isChecked)
        .map((student) => ({ studentId: student.studentId, classId: student.classId }));
    }
    const timedTimeSpan =
      parseInt(context.timedHour) * 60 + parseInt(context.timedMinute);
    const retakeTimeSpan = parseInt(context.retakeTimedHour * 60) + parseInt(context.retakeTimedMinute);
    
    const baseOptions = {
      classIds: selectedClassFilterIds,
      studentIds: notAssignedStudents.length === selectedStudents.length ? [-1] : selectedStudents.map(student => student.studentId),
      students: selectedStudents,
      selfAssign: false,
      availability: context.availabilityOption,
      allowAnswerChange: context.allowAnswerChange,
      startDate:
        context.startDate != ''
          ? moment(context.startDate).format('YYYY/MM/DD h:mm A')
          : '',
      endDate:
        context.endDate != ''
          ? moment(context.endDate).format('YYYY/MM/DD h:mm A')
          : '',
      studentFileUpload: context.studentFileUpload
    };

    const isFlashCard = activityType == ActivityTypes.FlashCard;
    let options = {
      ...baseOptions,
      assignmentMode: isFlashCard
        ? (context.activityMode === '' ? 'open' : context.activityMode)
        : (context.assignmentMode === '' ? 'open' : context.assignmentMode),
      ...(isFlashCard && { textToSpeech: context.textToSpeech }),
      ...(!isFlashCard && {
        showGrade: context.showGrade,
        timed: context.isTimed,
        timeSpan: timedTimeSpan,
        practice: true,
        autoLockQuestions: context.autoLockQuestions,
        allowLangChange: context.allowLangChange,
        useCalc: context.calculatorEnabled ? 1 : 0,
        useProtractor: context.useProtractor ? 1 : 0,
        useRuler: context.useRuler ? 1 : 0,
        timeOnTask: context.timeOnTaskEnabled,
        period: context.timeOnTaskSeconds,
        lockBrowser: context.lockBrowser,
        photoMathBlock: context.photoMathBlock,
        autoStartCRUponGrading: context.autoStartCRUponGrading,
        cranswerToolId: context.crAnswerToolType,
        calculatorType: context.calculatorType,
        studentPrinting: context.allowStudentToPrintPdf
      })
    };
    setIsAssigningStudents(true);

    if (activeTab === 0) {
      try {
        options.assignmentIds = [parseInt(assignmentId)];
        options.randomized = context.randomized;
        options.textToSpeech = context.textToSpeech;
        options.assignRetake = context.retakesEnabled;
        options.masteryLevel = context.masteryValue;
        options.retakeMode = context.retakeMode;
        options.scoreRetries = context.autoScoreRetries;
        options.retakeLimit = context.retakeLimitValue;
        options.retakeAvailability = context.retakeAvailabilty;
        options.retakeStartDate = context.retakeStartDate != ''
          ? moment(context.retakeStartDate).format('YYYY/MM/DD h:mm A')
          : '';
        options.retakeEndDate = context.retakeEndDate != ''
          ? moment(context.retakeEndDate).format('YYYY/MM/DD h:mm A')
          : '';
        options.retakeTimed = context.isRetakeTimed;
        options.retakeTimeSpan = activityType == ActivityTypes.FlashCard ? 0 : retakeTimeSpan;
        options.retakeQuestion = context.retakeQuestion == -1 ? 0 : context.retakeQuestion;
        options.includeCR = context.includeCR == 1;

        let response = [];
        if(activityType == ActivityTypes.FlashCard)
          response = await assignStudentsInFlashcard(options).unwrap();
        else
          response = await assignStudentsInAssignment(options).unwrap();

        setAssignedStudents([]);
        if (response.length > 0) {
          CustomToast(
            `${response[0].studentsAssigned} student${
              response[0].studentsAssigned == 1 ? ' has' : 's have'
            } been assigned`,
            'success'
          );
          setIsAssigningStudents(false);
          setConfirmModel(false);
          refetch();
        } else {
          CustomToast('Error! Couldn\'t Assign', 'error');
          setIsAssigningStudents(false);
        }
      } catch (ex) {
        console.log(ex);
        CustomToast(ex.data, 'error');
        setIsAssigningStudents(false);
        setConfirmModel(false);
      }
    } else {
      try {
        options.activity = 1;
        options.textToSpeech = context.textToSpeech;
        options.allowLanguageChange = context.allowLangChange;

        const changeModeDataResponse = await changeMode({
          assignmentId: assignmentId,
          data: options
        }).unwrap();
        setNotAssignedStudents([]);
        if (changeModeDataResponse > 0) {
          CustomToast(
            `${changeModeDataResponse} student${
              changeModeDataResponse == 1 ? `${activityType == ActivityTypes.FlashCard ? 'flashcard' : 'assignment'} has` : `${activityType == ActivityTypes.FlashCard ? 'flashcards' : 'assignments'} have`
            } been changed`,
            'success'
          );
          setIsAssigningStudents(false);
          refetch();
        } else {
          CustomToast(`Error! Couldn't change ${activityType == ActivityTypes.FlashCard ? 'flashcards' : 'assignments'}`, 'error');
          setIsAssigningStudents(false);
        }
      } catch (ex) {
        console.log(ex);
        CustomToast(`Error! Couldn't change ${activityType == ActivityTypes.FlashCard ? 'flashcards' : 'assignments'}`, 'error');
        setIsAssigningStudents(false);
      }
    }
  };

  const setClassIdsFilter = async (ids) => {
    try {
      await setclassFilter(ids).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Form.Group style={{ width: '25%', marginRight: '0.5vw' }}>
        <Form.Label htmlFor="classDropdown">Class</Form.Label>

        <DropDownSearch
          value={filterClassList}
          setValue={setFilterClassList}
          dropdownId="classesFilter"
          placeholder="Filter Classes"
          handleChange={(e) => handleClassSelectionChange(e)}
          selectedId={selectedClassFilterIds}
          setSelectedId={setSelectedClassFilterIds}
          description={true}
          selectAllText="All Classes"
          coteacherText={true}
          allData={allClassList}
        />
      </Form.Group>
      <div className="d-inline-flex my-4 assignStudentsTabs">
        <div className={`btn ${activeTab == 0 ? 'active' : ''}`} onClick={() => {setActiveTab(0); context.setIsStudentsAssigned(false);}}>
          Not Assigned
          <span className={activeTab == 0 ? 'activeCount' : 'count'}>{` (${
            notAssignedStudents.length
          })`}</span>
        </div>
        <div className={`btn ${activeTab == 1 ? 'active' : ''}`} onClick={() => {setActiveTab(1); context.setIsStudentsAssigned(true); context.setRetakesEnabled(false);}}>
          Assigned
          <span className={activeTab == 1 ? 'activeCount' : 'count'}>{` (${
            assignedStudents.length
          })`}</span>
        </div>
      </div>

      <div className={`assignmentSettingsPopOut ${showAssignmentSettings ? '' : 'hidden'}`}>
        {(activityType != ActivityTypes.FlashCard) ? (
          <AssignmentSettings
            allowRetakesOption={activityType != ActivityTypes.Assessment}
            headingDescription={false}
            availabilityRequired={true}
            modesRequired={true}
            showBetaButton={true}
            noColumn={true}
            allowOfflineMode={true}
            randomizedQuestion={activeTab === 0 ? true : false}
            disabledTextSpeach={true}
            isSelfAssign={false}
            showStudentPrinting={showStudentPrinting}
            isAssessment={activityType == ActivityTypes.Assessment}
          />
        ) : 
          (<ActivitySettings
            twoColumn={false}
          />)
        }

        <div className="assignButtonsRow gap-3 h-100">
          <Button
            className="btn-width"
            variant="castleGray"
            onClick={() => {
              setShowAssignmentSettings(false);
            }}>
            Cancel
          </Button>
          <Button
            className={activeTab == 0 && 'btn-width'}
            variant="castleRed"
            onClick={() => handleAssignStudents()}
            disabled={isAssigningStudents}>
            {`${activeTab === 0 ? 'Assign' : 'Change Mode'}`}
          </Button>
        </div>

        <div className="assignmentSettingsCloseBtn">
          <FontAwesomeIcon
            className="ms-2"
            size="2x"
            icon={faXmark}
            onClick={() => setShowAssignmentSettings(false)}
          />
        </div>
      </div>

      {tabs[activeTab]}
      <ConfirmationModal
        isOpen={confirmModel}
        onClose={() => setConfirmModel(false)}
        onSave={() => assignStudentsApiCall()}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={
          'The assignment contains CR Questions which will have to be scored prior to Automated Retakes being assigned to students who do not meet the Mastery Level. Do you still want to assign this assignment with Retakes?'
        }
        cancelButton={'NO'}
        confirmButton={'YES'}
        titleName={'Confirm'}
        hideheader={false}
      />
    </>
  );
}

export default AssignCastle;
